import { Injectable } from '@angular/core';
import { EditWebcastModel } from '../editWebcast/EditWebcastModel';

@Injectable({
	providedIn: 'root'
})
export class WebcastPreviewService {
	public fromPreviewButton: boolean;
	public webcastForm: EditWebcastModel;
}
